export {};
//# sourceMappingURL=auth-listener-event-detail.interface.js.map